import { Outlet } from 'react-router-dom'

import HolidaysComponent from 'modules/locations/pages/Locations/Holidays'

const AuthorizedHolidaysPage = () => {
  return (
    <HolidaysComponent>
      <Outlet />
    </HolidaysComponent>
  )
}

export default AuthorizedHolidaysPage
